require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./betreuungseinrichtungen-oberpullendorf-nikitsch.json") })
        }
      }, "path---betreuungseinrichtungen-oberpullendorf-nikitsch");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---betreuungseinrichtungen-oberpullendorf-nikitsch!./.cache/json/betreuungseinrichtungen-oberpullendorf-nikitsch.json
// module id = 986
// module chunks = 231608221292675